import React, { FC } from 'react';
import MuiGrid, { GridProps } from '@material-ui/core/Grid';

const Grid: FC<GridProps> = (props) => {
  return <MuiGrid {...props} />;
};

export default Grid;
